import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { MbbProduct } from '@sales/modules/mbb/models/mbb-product.model';
import { Store } from '@ngxs/store';
import { MbbProductUpdateAction } from '@sales/modules/mbb/states/customer-product-mbb.actions';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconNames } from '@shared/enums/icon-names';
import { MbbSubscriptionComponent } from '../../mbb-subscription/mbb-subscription.component';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-change-mbb-subscription',
  templateUrl: './change-mbb-subscription.component.html',
  styleUrls: ['./change-mbb-subscription.component.scss'],
  imports: [MatIcon, SpinnerComponent, FormsModule, ReactiveFormsModule, MbbSubscriptionComponent],
})
export class ChangeMbbSubscriptionComponent {
  private store = inject(Store);

  IconNames = IconNames;

  @Input() mbbProduct: MbbProduct;
  @Output() finishedSelection = new EventEmitter();

  form: FormGroup = new FormGroup({});

  onProductChange({ offering, changeInfo }) {
    this.store.dispatch(
      new MbbProductUpdateAction({ ...this.mbbProduct, mbbSubscription: offering, selectedChangeInfo: changeInfo })
    );
  }
}
